export default {"src":"/profile/_next/static/media/pp-tree.a870e1c4.svg","height":82,"width":120,"blurWidth":0,"blurHeight":0};